export class ApplicationServices {

    constructor(options = {}) {

        const {
            authManager = null,
            authService = null,
            httpService = null,
            serviceFactory = null,
            config = null,
            i18n = null,
            storage = null,
            logger = null,
            renderer = null,
        } = options;

        this.authManager = authManager;
        this.authService = authService;
        this.httpService = httpService;
        this.serviceFactory = serviceFactory;
        this.config = config;
        this.i18n = i18n;
        this.storage = storage;
        this.logger = logger;
        this.renderer = renderer;

    }

    getAuthManager() { return this.authManager; }

    getAuthService() { return this.authService; }

    getHttpService() { return this.httpService; }

    getServiceFactory() { return this.serviceFactory; }

    getConfig() { return this.config; }

    getI18n() { return this.i18n; }

    getStorage() { return this.storage; }

    getLogger() { return this.logger; }

    getRenderer() { return this.renderer; }

}
